<fui-rows>
    <fui-row>
        <fui-column>
            <wbo-edit-grid [data]="model.data.barcodes" [editable]="true" [removable]="true" [entityPath]="'barcodes'">
                <wbo-text-column field="barcode" [editable]="true"></wbo-text-column>
                <wbo-numeric-column field="stockSize.measureAmt" [editable]="true"></wbo-numeric-column>
                <wbo-measure-single-select-column field="stockSize.measure"
                                                  [inventoryMeasureIdentifier]="model.data.standardStockSize.measure.measureId"
                                                  [convertToRequired]="true"
                                                  [editable]="true"></wbo-measure-single-select-column>
                <wbo-edit-grid-add-row [identifierField]="'id'" #addRow>
                    <wbo-edit-grid-add-row-actions (onSelect)="addRow.addRow($event, true)">
                        <wbo-edit-grid-add-row-new></wbo-edit-grid-add-row-new>
                    </wbo-edit-grid-add-row-actions>
                </wbo-edit-grid-add-row>
            </wbo-edit-grid>
        </fui-column>
    </fui-row>
</fui-rows>
